import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { setUser } from "@/hooks/useLocalStorage";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function ToggleAgent({ user }) {
  const navigate = useNavigate();
  const [showAlert, setShowAlert] = useState(false);

  const handleAgentRole = (agentRole) => {
    setUser({ ...user, role: agentRole, agentRoleSelected: true });
    navigate(0);
  };

  useEffect(() => {
    if (
      !user.agentRoleSelected &&
      user.allowedRoles.includes("buyer_agent") &&
      user.allowedRoles.includes("seller_agent")
    ) {
      setShowAlert(true);
    }
  }, [user]);

  if (!showAlert) {
    return null;
  }

  return (
    <AlertDialog defaultOpen={showAlert}>
      <AlertDialogContent
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <AlertDialogHeader>
          <AlertDialogTitle>Select Your Profile Type</AlertDialogTitle>
          <AlertDialogDescription>
            Choose which profile you'd like to access. This will determine the
            features and tools available to you.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex flex-col sm:flex-row gap-2">
          <AlertDialogAction
            className="w-full"
            onClick={() => handleAgentRole("buyer_agent")}
          >
            Buyer Agent
          </AlertDialogAction>
          <AlertDialogAction
            className="w-full"
            onClick={() => handleAgentRole("seller_agent")}
          >
            Seller Agent
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export default ToggleAgent;
